import { ChakraProvider } from "@chakra-ui/react";
import React from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./pages/components/ScrollToTop";
import theme from "./theme";

import Landing from "./pages/Landing";
import NotFound from "./pages/NotFound";

import "@rainbow-me/rainbowkit/styles.css";
import VaultInfo from "./pages/VaultInfo";
import App from "./pages/App";

import { WagmiConfig, configureChains, createConfig } from "wagmi";
import { fantom, foundry } from "wagmi/chains";
import { publicProvider } from "wagmi/providers/public";

import { RainbowKitProvider, connectorsForWallets } from "@rainbow-me/rainbowkit";
import { injectedWallet } from "@rainbow-me/rainbowkit/wallets";
import { metaMaskWallet } from "@rainbow-me/rainbowkit/wallets";
import { jsonRpcProvider } from "@wagmi/core/providers/jsonRpc";

// react setup
const container = document.getElementById("root");
if (!container) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(container);

// wagmi+rainbowkit setup
const { chains, publicClient } = configureChains(
  [
    fantom,
    // foundry,
  ],
  [
    // publicProvider(),
    jsonRpcProvider({
      rpc: (chain) => ({
        http: `https://dawn-falling-sound.fantom.discover.quiknode.pro/e48d49e55dc94a2ea3330414af4047bfb7507cb9`,
      }),
    }),
    // jsonRpcProvider({ rpc: (chain) => ({ http: `http://localhost:8545/` }) }),
  ]
);
const connectors = connectorsForWallets([
  {
    groupName: "Recommended",
    wallets: [
      injectedWallet({ chains }),
      metaMaskWallet({
        projectId: "BTFDCA.finance",
        chains: chains,
      }),
    ],
  },
]);

const wagmiConfig = createConfig({
  autoConnect: true,
  connectors,
  publicClient,
});

// entry point
function Index() {
  return (
    <React.StrictMode>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/" element={<App />}>
          {/* <Route path="vaults" element={<Vaults />} /> */}
          <Route path="vaults/:vaultAddress" element={<VaultInfo />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </React.StrictMode>
  );
}

root.render(
  <WagmiConfig config={wagmiConfig}>
    <RainbowKitProvider chains={chains}>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <Index />
        </BrowserRouter>
      </ChakraProvider>
    </RainbowKitProvider>
  </WagmiConfig>
);
